import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRightIcon, PlusIcon } from "lucide-react";
import { Reveal } from "../Reveal";
import { useCart } from "../../contexts/CartContext";
import { products } from "../../data/products";
import { images } from "../../data/store";
import { formatPrice } from "../../utils/currency";
export function HoneyBar() {
  const {
    addItem
  } = useCart();
  const honey = products.filter(p => p.collection === "royal-honey");
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return <section className="border-t border-line bg-night py-20 lg:py-28" aria-labelledby="honey-title" data-id="element-237" data-mp="3lolc4enl7u2x">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-2 lg:gap-16" data-id="element-238" data-mp="3gt61rwosggb9">
        <div ref={ref} className="relative isolate flex min-h-[460px] flex-col justify-end overflow-hidden rounded-[28px] p-8 lg:sticky lg:top-28 lg:min-h-[560px] lg:self-start lg:p-10" data-id="element-239" data-mp="3cqjd24nezbia">
          <motion.img src={images.honey} alt="Golden honey dripping in dark light" style={{
          y
        }} className="absolute inset-x-0 -top-[10%] -z-10 h-[120%] w-full object-cover" data-id="element-240" data-mp="173wdao855k3h" />
          <div className="absolute inset-x-0 bottom-0 -z-10 h-2/3 bg-night/55" aria-hidden="true" data-id="element-241" data-mp="1l1kv1n6wwb4b" />
          <h2 id="honey-title" className="font-display text-5xl font-extrabold leading-[1.02] tracking-tight sm:text-6xl" data-id="element-242" data-mp="1q178nxqnjtdn">
            Liquid gold
            <br data-id="element-243" data-mp="1c38x103pub1u" />
            <span className="text-brand" data-id="element-244" data-mp="1g2rgdrfw2e2k">for your nights.</span>
          </h2>
          <p className="mt-4 max-w-sm text-white/80" data-id="element-245" data-mp="1g4ugx5eo3plj">
            Single-use royal honey sachets and chocolate. Tear, take, and feel the difference.
          </p>
        </div>

        <div className="flex flex-col" data-id="element-246" data-mp="4odzx7ngt0wk">
          <Reveal className="flex items-end justify-between gap-4" data-id="element-247" data-mp="27a9u0t37q97h">
            <div data-id="element-248" data-mp="279hx9exvq5fm">
              <p className="font-display text-2xl font-bold" data-id="element-249" data-mp="27c441ccy4gws">Honey &amp; Choco</p>
              <p className="mt-1 text-sm text-muted" data-id="element-250" data-mp="22byj0f16lsno">Every item {formatPrice(14.99)}</p>
            </div>
            <Link to="/shop?collection=royal-honey" className="group inline-flex items-center gap-1.5 text-sm font-semibold text-brand" data-id="element-251" data-mp="1xin7i0lfcnpf">
              View all
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-252" data-mp="1ohp33h72qe6b" />
            </Link>
          </Reveal>
          <ul className="mt-6 space-y-3" data-id="element-253" data-mp="1emdnkwnud2xi">
            {honey.map((p, i) => <li key={p.slug} data-id="element-254" data-mp="19nat265hmf3s" data-mpi={i}>
                <Reveal delay={i * 0.05} y={16} data-id="element-255" data-mp="19o2forh3x2hx">
                  <div className="group flex items-center gap-4 rounded-2xl border border-line bg-surface p-3 pr-4 transition-colors hover:border-brand/50" data-id="element-256" data-mp="38zd8n5azqpc6">
                    <Link to={`/product/${p.slug}`} className="shrink-0 overflow-hidden rounded-xl bg-white" data-id="element-257" data-mp="341bp6j9nko06">
                      <img src={p.images[0]} alt="" className="h-20 w-20 object-contain transition-transform duration-300 ease-brand group-hover:scale-110" data-id="element-258" data-mp="3cfgfo1zi9h01" />
                    </Link>
                    <div className="min-w-0 flex-1" data-id="element-259" data-mp="3q8fwq8exrj9p">
                      <Link to={`/product/${p.slug}`} className="block truncate font-display text-lg font-semibold transition-colors hover:text-brand" data-id="element-260" data-mp="2tj6tssid3m5h">
                        {p.name}
                      </Link>
                      <p className="truncate text-sm text-muted" data-id="element-261" data-mp="37ig9zs6kig9g">{p.tagline}</p>
                    </div>
                    <span className="hidden font-display font-bold sm:block" data-id="element-262" data-mp="hte92wmthrf8">{formatPrice(p.price)}</span>
                    <button type="button" onClick={() => addItem(p.slug)} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-night transition-[background-color,transform] duration-200 hover:rotate-90 hover:bg-brand active:scale-90" aria-label={`Add ${p.name} to cart`} data-id="element-263" data-mp="mrpk3aoum7z1">
                      <PlusIcon className="h-5 w-5" data-id="element-264" data-mp="1zppqyghkg5cy" />
                    </button>
                  </div>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}